
<template>
<!-- 答题卡导入 -->
  <div class="modal-import">
    <el-dialog
      title="导入"
      :visible.sync="dialogVisible"
      width="30%"
      @close="closeDialog"
      custom-class="dialog_import"
      >
      <p style="margin: 0 0 35px 12px;color: #999">
        粘贴分享答题卡ID复用至当前账号答题卡列表：
      </p>
      <el-form ref="ruleForm">
        <el-form-item label="答题卡ID: " :label-width="formLabelWidth">
          <div style="display: flex">
          <el-input v-model="formdata.shareCode" autocomplete="off" style="width: 300px !important">
            <el-button type="primary" slot="append" @click="handleSubmit()" :loading="submitBtnLoading">确定</el-button>
          </el-input>
          </div>
           </el-form-item>
        <el-form-item label="答题卡名称: " :label-width="formLabelWidth">
          <span v-html="formdata.CardName || '-'"></span>
          <!-- <el-input v-model="formdata.acCardName" autocomplete="off" style="width: 300px !important"></el-input> -->
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleCancel('cancel')">取 消</el-button>
        <el-button type="primary" @click="handleImport()"  :loading="importBtnLoading"  :disabled='!formdata.canImport'>导 入</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import AcCardApi from "@/services/acCard"
import { mapState, mapMutations } from "vuex";
export default {
  props:{
    value: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
  ...mapState("card", {
    kMAndPeriod: (state) => state.kMAndPeriod, //学科和学段的字典
    }),
  },
  data() {
    return {
      formLabelWidth: '100px',
      dialogVisible: false,
      formdata: {
        shareCode: '', // 模板名称
        CardName: '', // 答题卡name
        canImport: false, // 是否可以导入
      },
      submitBtnLoading: false,
      importBtnLoading: false,
    }
  },
  methods: {
    async handleSubmit(formName) {
      if(!this.formdata.shareCode) {
        return this.$message({
          message: '请输入正确的答题卡ID',
          type: 'warning'
        });
      }
      this.submitBtnLoading = true;
      const result = await AcCardApi.GetShareCardName({
        shareCode: this.formdata.shareCode,
      });
     if(result.status == 200) {
        this.formdata.CardName = result.data.CardName;
        this.formdata.canImport = true;
      } else {
        // if(result.status != 403) {
        //   this.$message({
        //     message: result.message,
        //     type: 'error'
        //   });
        // }
      }
      this.submitBtnLoading = false;
      // this.dialogVisible = false;
    },
    async handleImport() {
      this.importBtnLoading = true;
      const result = await AcCardApi.ShareToCard({
        shareCode: this.formdata.shareCode,
      });
      if(result.status == 200) {
        this.dialogVisible = false;
        this.$emit('onSuccess');
        this.$message({
          message: '操作成功~',
          type: 'success'
        });
      } else {
        // if(result.status != 403) {
        //   this.$message({
        //     message: result.message,
        //     type: 'error'
        //   });
        // }
      }
      this.formdata.canImport = false;
      this.formdata.CardName = undefined;
      this.importBtnLoading = false;

    },
    handleCancel(name) {
      this.dialogVisible = false;
    },
    closeDialog(){
        this.isShow = false;
        this.$emit('input', false);
        this.formdata.shareCode = '';
        this.formdata.CardName = '';
        this.submitBtnLoading = false;
        this.importBtnLoading = false;
    },
    async GetShareCardName() {
      const result = await AcCardApi.GetShareCardName(this.formdata);
    }
  },
  watch: {
    value(newVal) {
      if(newVal) {
        this.dialogVisible = true;
      }
    },
    kMAndPeriod(newVal) {
      this.formdata.Period = newVal.Period[0].value;
      this.formdata.KmCode = newVal.KM[0].value;
    }
  },
  mounted() {
  }
}
</script>

<style lang="scss" >
.modal-import{
.el-select .el-input{
  width: 300px !important;
}
.el-input-group__append{
  background-color: #66b1ff;
  color: #fff;
  border: 1px solid #66b1ff;
}

}
.dialog_template_add{
.el-form-item span{
  padding: 0;
}
}

</style>